// extracted by mini-css-extract-plugin
export var animationContainer = "_hp-0";
export var asteriskIcon = "_hp-8";
export var conversationLeftSection = "_hp-4";
export var conversationListItem = "_hp-3";
export var conversationMiddleSection = "_hp-5";
export var conversationRightSection = "_hp-6";
export var detailsContent = "_hp-1";
export var listContainer = "_hp-7";
export var modalContent = "_hp-2";